import { callFetch, idTokenHeader, tokenHeader } from "./utils";

const EndPoint = {
  GetFamilyStore: (filter) => `/linewebhook/store/family?filter=${filter}`,
  GetSevenStore: (filter) => `/linewebhook/store/seven?filter=${filter}`,
};

export function getFamilyStores(data = { filter: { city: "", district: "" } }, idToken) {
  const filters = JSON.stringify(data);
  const uri = EndPoint.GetFamilyStore(filters);
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}

export function getSevenStores(data = { filter: { city: "", district: "" } }, idToken) {
  const filters = JSON.stringify(data);
  const uri = EndPoint.GetSevenStore(filters);
  let settings = {
    method: "GET",
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callFetch(uri, settings);
}
